// Arquivo: src/routes/app.routes.tsx

import React from 'react';
import { Switch } from 'react-router-dom';
import PrivateRoute from '../components/PrivateRoute'; 

// Todos os seus imports de páginas continuam os mesmos
import Dashboard from '@pages/Dashboard';
import ListaEmpresas from '@pages/Contratos/ContratosEmpresas';
// IMPORTE O NOVO COMPONENTE
import ContratosInativos from '@pages/Contratos/ContratosInativosEmp';
import ListaCredenciados from '@pages/Contratos/ContratosCredenciados';
import CadastroContratosEmp from '@pages/Contratos/ContratosEmpresas/CadastroContratosEmp';
import CadastroContratosCred from '@pages/Contratos/ContratosCredenciados/CadastroContratosCredenciados';
import EmpresaRH from '@pages/EmpresasRH/CadastroEmpresa';
import { Credenciados } from '@pages/Credenciados';
import { CadastrarCredenciado } from '@pages/Credenciados/CadastroCredenciado/cadastroCredenciado';
import { EditarCredenciado } from '@pages/Credenciados/EditarCredenciado/editarCredenciado';
import { Agendamentos } from '@pages/Agendamentos';
import { EditAgendamento } from '@pages/Agendamentos/MarcarHorario/editAgendamento';
import Administrativo from '@pages/Administrativos';
import Empresas from '@pages/EmpresasRH/Empresa';
import { EditContract } from '@pages/Contratos';
import { Ghe } from '@pages/EmpresasRH/GHE';
import { Localobra } from '@pages/EmpresasRH/LocalObra';
import { Cadastroghi } from '@pages/EmpresasRH/GHE/CadastroGHE';
import { Cadastrolocalobra } from '@pages/EmpresasRH/LocalObra/CadastroLocalObra';
import EditEmpresaRH from '@pages/EmpresasRH/CadastroEmpresa/editEmpRh';
import { EditLocalObra } from '@pages/EmpresasRH/LocalObra/EditLocalObra/editLocalObra';
import { EditGhe } from '@pages/EmpresasRH/GHE/EditGHE/editGhe';
import { Coloboradores } from '@pages/Colaboradores';
import { CadastrarColaborador } from '@pages/Colaboradores/CadastrarColaborador/cadastrarColaborador';
import { EditarColaborador } from '@pages/Colaboradores/EditarColaborador/editarColaborador';
import { MarcarHorario } from '@pages/Agendamentos/MarcarHorario';
import { PDF } from '@pages/Agendamentos/PDF/gerarPdf';
import { Comparativo } from '@pages/Financeiro/Comparativo';
import { ExamesCredenciados } from '@pages/Financeiro/ExamesCredenciados';
import { ExamesEmpresas } from '@pages/Financeiro/ExamesEmpresas';
import Kit from '@pages/Kit';
import { ExamesAvencer } from '@pages/ExamesAvencer';
import { Esocial } from '@pages/Esocial';
import { EditarEsocial } from '@pages/Esocial/EditarEsocial';
import { AgenExterno } from '@pages/Agendamentos/AgenExterno';
import Atua_Empresas from '@pages/Contratos/AtuaContratoEmp'
import NovoContratoEmpresa from '@pages/Contratos/AtuaContratoEmp/NovoContratoEmp'

const AppRoutes: React.FC = () => (
  <Switch>
    <PrivateRoute path="/dashboard" exact component={Dashboard} />
    <PrivateRoute path="/credenciados" component={Credenciados} />
    <PrivateRoute path="/cadastro-credenciados" component={CadastrarCredenciado} />
    <PrivateRoute path="/editar-credenciado" component={EditarCredenciado} />

    <PrivateRoute path="/agendamentos" component={Agendamentos} />
    <PrivateRoute path="/agendar" component={MarcarHorario} />
    <PrivateRoute path="/editar-agendamento" component={EditAgendamento} />

    <PrivateRoute path="/agendamentos-wp" component={AgenExterno} />
 
    <PrivateRoute path="/contratos-empresa" component={ListaEmpresas} />
    
    {/* NOVA ROTA PARA CONTRATOS INATIVOS */}
    <PrivateRoute path="/contratos-empresa-inativos" component={ContratosInativos} />
    
    <PrivateRoute path="/contratos-credenciado" component={ListaCredenciados} />
    <PrivateRoute path="/cadastro-contrato-empresa" component={CadastroContratosEmp} />
    <PrivateRoute path="/cadastro-contrato-credenciado"  component={CadastroContratosCred} />

    <PrivateRoute path="/atua-empresas" component={Atua_Empresas} />
    <PrivateRoute path="/novo-contr-empresas" component={NovoContratoEmpresa} />

    <PrivateRoute path="/cadastro-empresas" component={EmpresaRH} />
    <PrivateRoute path="/PDF" component={PDF as any} />

    <PrivateRoute path="/edit-empresa-rh" component={EditEmpresaRH} />
    <PrivateRoute path="/empresa-rh" component={Empresas} />
    <PrivateRoute path="/editar-contrato" component={EditContract} />
    <PrivateRoute path="/local-obra" component={Localobra} />
    <PrivateRoute path="/editar-local-obra" component={EditLocalObra} />
    <PrivateRoute path="/ghe" component={Ghe} />
    <PrivateRoute path="/edit-ghe" component={EditGhe} />
    <PrivateRoute path="/cadastro-ghe" component={Cadastroghi} />
    <PrivateRoute path="/cadastro-local-obra" component={Cadastrolocalobra} />
    <PrivateRoute path="/colaboradores" component={Coloboradores} />
    <PrivateRoute path="/cadastro-colaborador" component={CadastrarColaborador} />
    <PrivateRoute path="/editar-colaborador" component={EditarColaborador} />
    <PrivateRoute path="/comparativo-exames" component={Comparativo} />
    <PrivateRoute path="/exames-credenciados" component={ExamesCredenciados} />
    <PrivateRoute path="/exames-empresas" component={ExamesEmpresas} />
    <PrivateRoute path="/exames-a-vencer" component={ExamesAvencer} />
    <PrivateRoute path="/e-social" component={Esocial} />
    <PrivateRoute path="/edit-e-social" component={EditarEsocial} />
    <PrivateRoute path="/kit" component={Kit} />

    <PrivateRoute path="/adm" component={Administrativo} />
  </Switch>
);

export default AppRoutes;